import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { CompanyBanner } from '@/services/dataTypes';
import { getBaseImageUrl } from '@/constants/hooks';

interface Props {
  bannerResponse: CompanyBanner[];
  domain: string;
}

const Carousel = ({ bannerResponse, domain }: Props) => {
  return (
    <div className="flex gap-2 md:gap-3">
      {bannerResponse.map((item, i) => {
        const isLarge = i % 2 === 0 ? 'small' : 'large';
        const colClass = isLarge === 'large' ? 'md:w-1/2' : 'md:w-1/4';

        return (
          <div key={i} className={colClass}>
            <section className="my-2 transition-transform duration-300 hover:scale-105">
              <div className="w-full h-full">
                <Image
                  className="w-full rounded-lg md:rounded-xl"
                  height={isLarge === 'large' ? 347 : 340}
                  width={isLarge === 'large' ? 552 : 270}
                  src={getBaseImageUrl(domain, item?.image, '')}
                  alt={item?.text || "Promotional Banner"}
                  style={{ objectFit: 'cover' }}
                  priority={i === 0}
                />
              </div>
            </section>
            <div className="text-center my-2 md:my-3 border rounded-lg bg-white p-2 md:p-3">
              <span className="text-gray-800 font-bold text-sm md:text-base lg:text-lg line-clamp-2">
                {item?.text}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Carousel;
